import { getUserInfoAPI } from '@/api/user.js'
import {getUserInfo } from '@/api/user'
import router from '@/router'


// 用户模块
const userModule = {
  namespaced: true,
  state() {
    return {
      userInfo: {},
      users: {},
      token: localStorage.getItem('token') || '',
      isLeader: false,
      isAdmin: false
    }
  },
  mutations: {
    getUserInfo(state, user) {
      console.log('getUserInfo mutation - user data:', user)
      state.userInfo = user
      state.isLeader = user.leader === 1
      state.isAdmin = user.is_admin === 1
      console.log('isLeader:', state.isLeader, 'isAdmin:', state.isAdmin)
      state.token = user.token
      localStorage.setItem('token', state.token)
    },
    getUser(state, users) {
      state.users = users
    },
    changeuserinfo(state) {
      state.userInfo = {}
      state.token = ''
      state.isLeader = false
      state.isAdmin = false
      localStorage.setItem('token', '')
      router.push('/login')
    }
  },
  actions: {
    async asyncGetUserInfo({ dispatch, commit }, user) {
      const { data: res } = await getUserInfoAPI(user)
      if (res.code !== 200) {
        localStorage.removeItem('token')
        localStorage.removeItem('vuex')
        return { type: 'error', message: res.msg }
      } else {
        commit('getUserInfo', res.data)
        dispatch('asyncGetUser')
        return { type: 'success', message: '登录成功！' }
      }
    },
    async asyncGetUser({ commit }, user) {
      const res2 = await getUserInfo()
      if (res2.data.code !== 200) {
        return { type: 'error', message: res2.msg }
      } else {
        commit('getUser', res2.data.data)
      }
    },
  },
  getters: {
    isLeader(state) {
      return state.isLeader
    },
    isAdmin(state) {
      return state.isAdmin
    }
  }
}
export default userModule
